<template>
  <div>
    <canvas id="BarChart" class="img-bar-chart"></canvas>
  </div>
</template>
<script>
export default {
  props: {
    slabels: {
      type: Object,
      default: {}
    }
  },

  methods: {
    BarChart() {
      const jsonData = JSON.parse(JSON.stringify(this.slabels))
      var barChartData = jsonData
      //  if(window.BarChart){ window.BarChart.destroy()}
      var ctx = document.getElementById('BarChart').getContext('2d')

      window.BarChart = new Chart(ctx, {
        type: 'bar',
        data: barChartData,
        options: {
          title: {
            display: false,
            text: ''
          },
          legend: {
            display: false
          },
          tooltips: {
            enabled: true,
            custom: function(tooltipModel) {}
          },
          animation: {
            duration: 1000,
            currentStep: 1,
            onComplete: function() {
              var chartInstance = this.chart,
                ctx = chartInstance.ctx
              ctx.textAlign = 'center'
              ctx.textBaseline = 'bottom'
              var stackGroup = []
              var stackIndex = []
              this.data.datasets.forEach(function(dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i)
                meta.data.forEach(function(bar, index) {
                  var data = dataset.data[index]
                  var result = stackGroup.filter((obj) => {
                    return obj.stackIndex === i
                  })
                  if (result.length > 0) {
                    if (result[0].Name == 'Stack 0') {
                      ctx.fillText('Completed', bar._model.x, bar._model.y - 5)
                    }
                    if (result[0].Name == 'Stack 1') {
                      var str = 'Not<br/>Completed'
                      var html = $.parseHTML(str)
                      ctx.fillText('NotCompleted', bar._model.x, bar._model.y - 5)
                    }
                  }
                  //if($.inArray(i, stackIndex) !== -1){
                  //ctx.fillText(data, bar._model.x, bar._model.y - 5);
                  //}
                })
              })
            }
          },
          responsive: true,
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true,
                scaleLabel: {
                  display: false,
                  labelString: 'Task Count'
                }
              }
            ]
          }
        }
      })
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.BarChart()
    })
  },
  watch: {
    slabels: {
      deep: true,
      handler() {
        window.BarChart.destroy()
        this.BarChart()
      }
    }
  }
}
</script>
